import {
   ChangeDetectionStrategy,
   Component,
   EventEmitter,
   Input,
   OnInit,
   Output,
   ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CallState } from '@lcs/shared/api';
import { AddClosedExceptionData } from '../../closed-exceptions/models/closed-exceptions.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-add-closed-exception-view',
    styleUrls: ['./add-closed-exception-view.component.scss'],
    templateUrl: './add-closed-exception-view.component.html',
    standalone: false
})
export class AddClosedExceptionViewComponent implements OnInit {
   @Input() callState: CallState;

   @Input() form: UntypedFormGroup;

   @Input() title: string;

   @Input() accountId: number | null;

   @Input() scheduleId: number | null;

   @Output() formSubmitted = new EventEmitter<AddClosedExceptionData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Output() timeToggleClicked = new EventEmitter<boolean>();

   @Output() addNewPromptClick = new EventEmitter<void>();

   timeToggleChecked = false;

   showSchedulesMultiSelect = false;

   ngOnInit() {
      this.form.get('startTime')?.value ? (this.timeToggleChecked = true) : this.form.get('startTime')?.disable();
      this.form.get('endTime')?.value ? (this.timeToggleChecked = true) : this.form.get('endTime')?.disable();
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      } else {
         this.form.markAllAsTouched();
      }
   }

   onTimeToggleClick(timeToggleChange: MatSlideToggleChange): void {
      this.form.patchValue({
         startTime: null,
         endTime: null,
      });
      if (timeToggleChange.checked) {
         this.form.get('startTime')?.enable();
         this.form.get('endTime')?.enable();
      } else {
         this.form.get('startTime')?.disable();
         this.form.get('endTime')?.disable();
      }
      this.timeToggleChecked = timeToggleChange.checked;
   }

   onCopyToSchedulesClick(checkbox: MatCheckboxChange): void {
      this.showSchedulesMultiSelect = checkbox.checked;
      if (!this.showSchedulesMultiSelect) {
         this.form.controls.schedulesToCopyTo.setValue([]);
         this.form.controls.schedulesToCopyTo.markAsPristine();
      }
   }

   onAddPromptClick(event): void {
      this.addNewPromptClick.emit();
   }

   emitScheduleChange() {
      this.form.controls.schedulesToCopyTo.markAsDirty();
   }

   isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
   }
}
